import { render } from "./CurrentSeasonStat.vue?vue&type=template&id=ac600b52&scoped=true"
import script from "./CurrentSeasonStat.vue?vue&type=script&lang=js"
export * from "./CurrentSeasonStat.vue?vue&type=script&lang=js"

import "./CurrentSeasonStat.vue?vue&type=style&index=0&id=ac600b52&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac600b52"]])

export default __exports__